/**
 * Mini globo terráqueo wireframe que gira en 3D simulado mediante animación
 * del radio horizontal de los meridianos. Limpio, ligero y profesional.
 */
const TravelNavBadge = ({ active }) => {
  const color = active ? "#7DD500" : "#9eff2e";
  return (
    <span className="inline-flex items-center gap-2" data-testid="travel-nav-badge">
      <svg
        viewBox="0 0 32 32"
        className="w-6 h-6 shrink-0"
        style={{ filter: `drop-shadow(0 0 4px ${color}55)` }}
        aria-hidden="true"
      >
        <defs>
          <clipPath id="tnb-clip">
            <circle cx="16" cy="16" r="13.5" />
          </clipPath>
        </defs>
        {/* Esfera */}
        <circle cx="16" cy="16" r="14" fill="#0a1628" stroke={color} strokeWidth="1" opacity="0.9" />
        <g clipPath="url(#tnb-clip)">
          {/* Meridianos: 3 elipses cuyo rx oscila para simular rotación 3D */}
          <ellipse cx="16" cy="16" ry="13.5" fill="none" stroke={color} strokeWidth="0.8" opacity="0.95">
            <animate attributeName="rx" values="13.5;0;13.5" dur="4s" repeatCount="indefinite" />
            <animate attributeName="opacity" values="0.95;0.3;0.95" dur="4s" repeatCount="indefinite" />
          </ellipse>
          <ellipse cx="16" cy="16" ry="13.5" fill="none" stroke={color} strokeWidth="0.8" opacity="0.7">
            <animate attributeName="rx" values="9;13.5;0;9;13.5;0;9" dur="4s" repeatCount="indefinite" />
            <animate attributeName="opacity" values="0.7;0.95;0.3;0.7" dur="4s" repeatCount="indefinite" />
          </ellipse>
          <ellipse cx="16" cy="16" ry="13.5" fill="none" stroke={color} strokeWidth="0.8" opacity="0.5">
            <animate attributeName="rx" values="0;13.5;0" dur="4s" repeatCount="indefinite" />
            <animate attributeName="opacity" values="0.3;0.95;0.3" dur="4s" repeatCount="indefinite" />
          </ellipse>
          {/* Paralelos (estáticos) */}
          <line x1="2.5" y1="16" x2="29.5" y2="16" stroke={color} strokeWidth="0.7" opacity="0.85" />
          <ellipse cx="16" cy="16" rx="13.5" ry="6" fill="none" stroke={color} strokeWidth="0.5" opacity="0.55" />
          <ellipse cx="16" cy="16" rx="13.5" ry="10.5" fill="none" stroke={color} strokeWidth="0.4" opacity="0.35" />
        </g>
        {/* Brillo */}
        <circle cx="11" cy="11" r="2.5" fill="white" opacity="0.12" />
      </svg>
      <span className={`font-bold tracking-wider ${active ? "text-[#7DD500]" : ""}`}>TRAVEL</span>
    </span>
  );
};

export default TravelNavBadge;
